// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/BloqueiosAgenda_ListForAgendaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /bloqueios_agenda/list_for_agenda
 *
 * Returns array of calendar-formatted bloqueio records with enriched data.
 */
import type { BloqueiosAgenda_ListForAgendaRow } from './BloqueiosAgenda_ListForAgendaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type BloqueiosAgenda_ListForAgendaResponseDados = BloqueiosAgenda_ListForAgendaRow[];

export type BloqueiosAgenda_ListForAgendaResponse = ApiResponse<BloqueiosAgenda_ListForAgendaResponseDados>;

registerResponseContract('BloqueiosAgenda_ListForAgendaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      bloqueio_agenda_id:               { type: 'number',  required: true },
      bloqueio_agenda_titulo:           { type: 'string',  required: false },
      bloqueio_agenda_operador_user_id: { type: 'string',  required: false },
      bloqueio_agenda_criador_user_id:  { type: 'string',  required: false },
      bloqueio_agenda_data_hora_inicio: { type: 'string',  required: true },
      bloqueio_agenda_data_hora_fim:    { type: 'string',  required: true },
      bloqueio_agenda_data_cadastro:    { type: 'string',  required: false },
      start:                            { type: 'string',  required: false },
      end:                              { type: 'string',  required: false },
      bloqueio_operador_nome:           { type: 'string',  required: false },
      backgroundColor:                  { type: 'string',  required: false },
      borderColor:                      { type: 'string',  required: false },
      avatar_operador:                  { type: 'string',  required: false },
    },
  },
})
